module.exports = __webpack_public_path__ + "static/media/EBGaramond-Regular.bf355e62.woff2";